module.exports = __webpack_public_path__ + "img/watch.4d6e06fc.jpg";